import React from "react";
import { Route, Switch } from "react-router-dom";
import Loadable from "react-loadable";
import { ImportLoading } from "./common";
import App from "grommet/components/App";
import Status from "./Status";

import "grommet/grommet.min.css";

const AsyncPrivate = Loadable({
  loader: () => import("./PrivateLayout"),
  loading: ImportLoading
});

const AsyncPublic = Loadable({
  loader: () => import("./PublicLayout"),
  loading: ImportLoading
});

const AsyncNotFound = Loadable({
  loader: () => import("./features/NotFound"),
  loading: ImportLoading
});


export const Routes = () => (
  <App centered={false}>
    <Status />
    <Switch>
      <Route path="/app" component={AsyncPrivate} />
      <Route path="/auth" component={AsyncPublic} />
      {/*Following routes must be last in the switch statements */}
      <Route component={AsyncNotFound} />
    </Switch>
  </App>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js